import React from 'react';
import PropTypes from 'prop-types';
import lealChatIcon from 'assets/icons/leal_role_chat.png';
import { useNbaChat } from '../useNbaChat';
import { ChatBubble } from './ChatBubble';

export const NbaChatPopup = ({ closePopup }) => {
  const { loading, handleSendMessage, chatHistory } = useNbaChat();

  return (
    <ChatBubble
      isOpen
      onClose={closePopup}
      chatHistory={chatHistory}
      onSendMessage={handleSendMessage}
      isLoading={loading}
      avatarSrc={lealChatIcon}
      inputPlaceholder="Ask me anything... "
    />
  );
};

NbaChatPopup.propTypes = {
  closePopup: PropTypes.func.isRequired,
};
